import { AfterViewInit, Component, ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-phone-bonuses-modal',
  template: `
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <div class="label blue-label">Bonus activated</div>
    <div class="_10px-spacer"></div>
    <h3>You got 27 free spins:</h3>
    <img src="/assets/images/bonus-img-1.png" height="200" />
    <p>You got 20 Roulette Free Spins & 7 Slot Free Spins</p>
    <a [routerLink]="['/account/bonus', { outlets: { modal: null } }]" (click)="close()">
      <app-form-button class="primary full-width"> Activate your bonus </app-form-button>
    </a>
    <div class="log-in-or-text">Or</div>
    <a [routerLink]="['/', { outlets: { modal: 'deposit' } }]" (click)="close()" class="button-transparent full-width">
      Deposit & get up to 7 BTC
    </a>
  `,
  styles: [
    `
      :host {
        text-align: center;
        align-items: center;
        display: flex;
        flex-direction: column;
      }

      .log-in-or-text {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .button-transparent {
        height: 45px;
        min-width: 140px;
        border-style: solid;
        border-width: 1px;
        border-color: hsla(0, 0%, 100%, 0.1);
        border-radius: 6px;
        background-color: transparent;
        box-shadow: 11px 11px 30px 0 transparent;
        transition: box-shadow 0.2s ease, -webkit-transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
        transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.2s ease;
        transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.2s ease,
          -webkit-transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
        line-height: 45px;
        width: 100%;
      }

      .button-transparent:hover {
        background-image: -webkit-gradient(
          linear,
          left top,
          left bottom,
          from(hsla(0, 0%, 100%, 0.1)),
          to(hsla(0, 0%, 100%, 0.1))
        );
        background-image: linear-gradient(180deg, hsla(0, 0%, 100%, 0.1), hsla(0, 0%, 100%, 0.1));
        box-shadow: 11px 11px 30px 0 rgba(0, 0, 0, 0.2);
        -webkit-transform: translate(0, -2px);
        -ms-transform: translate(0, -2px);
        transform: translate(0, -2px);
      }
    `,
  ],
})
export class PhoneBonusesModalComponent extends AnimatedModalComponent implements AfterViewInit {
  data: { available: number } = { available: 0 };

  constructor(
    private ref: NgbActiveModal,
    protected elRef: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected http: HttpClient
  ) {
    super(elRef, renderer);
  }

  ngAfterViewInit() {}

  public close(): void {
    this.ref.close(0);
  }

  public reject(): void {
    this.ref.dismiss(1);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/phone-bonuses-modal.component.ts